import React, {Component, Fragment} from "react";
import {Header, Rating} from "semantic-ui-react";

import {Header as MyHeader} from "../../components";

import {Courses} from '../Courses/Courses';
import {CourseDetails} from '../Courses/CourseDetails';

import {Comments, Countdown, Description} from "./components";
import {getCategory, getPlace} from "../../redux/actions";
import {isUndefined} from "lodash";
import queryString from "query-string";

class Details extends Component {

    constructor(props) {
        super(props);

        const {id, slug, from} = props.match.params;

        this.state = {
            course_id: 0,
            place_id: id,
            place_slug: slug,
            place: {},
            category: {},
            isLoading: false,
            from,
        };

        this.stopLoading = this.stopLoading.bind(this);
    }

    stopLoading() {
        this.setState({isLoading: false});
    }

    componentDidMount() {

        window.scrollTo(0, 0);

        const {from, place_id} = this.state;

        this.setState({isLoading: true});

        getPlace(from, place_id)
            .then(({data}) => {
                this.setState({
                    place: data.data
                })
            })
            .catch(err => {
                console.log('error', err);
            })
            .then(this.stopLoading);


        // if (this.props.location.state && this.props.location.state.category) {
        //     this.setState({
        //         ...this.props.location.state
        //     });
        //
        //     return;
        // }

        const values = queryString.parse(this.props.location.search);
        const course_id = values.course_id || 0;
        let category = values.category || 0;

        if (category) {
            getCategory(category).then(({data}) => {
                this.setState({
                    course_id,
                    category: data
                })
            });
        } else {
            this.setState({
                course_id
            })
        }
    }

    render() {
        const {place, course_id, category, from} = this.state;
        const {name, score_avg, score_count, price_start, price_end, banner, start, buy_url, paths, categories} = place;
        const {location} = this.props;

        let image = banner;
        let category_image = false;
        let my_category_id = undefined;

        if (!isUndefined(categories)) {

            my_category_id = categories[0]['id'];

            let i = 0;
            for (let ix in categories) {

                let id = categories[ix]['id'];
                let parent = categories[ix]['parent_id'];
                let parent2 = categories[ix]['parent'] && categories[ix]['parent']['parent_id'];

                if (id === category.id || parent === category.id || parent2 === category.id) {

                    i = ix;
                    my_category_id = id;
                }
            }

            if (!image) {
                if (categories[i]['image']) {
                    image = categories[i]['image'];
                    category_image = true;
                } else if (categories[i]['parent']['image']) {
                    image = categories[i]['parent']['image'];
                    category_image = true;
                } else if (!isUndefined(category) && category.image) {
                    image = category.image;
                    category_image = true;
                }
            }
        }

        if (!place.id) {
            return (
                <React.Fragment>
                    <MyHeader banner={image} category={category_image} verticalAlign={'bottom'}>
                        <Header as="h2" className={'details'} />
                    </MyHeader>
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                <MyHeader banner={image} category={category_image} verticalAlign={'bottom'}>
                    <Header as="h2" className={'details'}>
                        {name}
                        {
                            from === 'places' && <>
                                <div>
                                    {(my_category_id && !isUndefined(paths[my_category_id])) && paths[my_category_id]}
                                </div>
                                {
                                    score_count > 0 && <>
                                        <Rating
                                            maxRating={5}
                                            defaultRating={score_avg}
                                            icon="star"
                                            size="mini"
                                            disabled
                                        />
                                        <small style={{fontSize: 14}}>({score_count})</small>
                                    </>
                                }
                            </>
                        }
                    </Header>
                    {
                        (from === 'places' && price_start && price_end > 0) &&
                        <div className="price">{`R$${price_start} - R$${price_end}`}</div>
                    }
                </MyHeader>

                {from === 'events' && <Countdown eventStart={start} buyUrl={buy_url}/>}
                {
                    !course_id ? <React.Fragment>
                        <Description
                            from={from}
                            id={place.id}
                            score_avg={score_avg}
                            pathname={location.pathname}
                            about={place.about}
                            description={place.description}
                            name={place.name}
                            address={{
                                formatted_address: place.formatted_address,
                                lat: place.lat,
                                lng: place.lng,
                            }}
                            hours={place.place_hours}
                            contact={{
                                email: place.email,
                                site: place.site,
                                phone_1: place.phone_1,
                                phone_2: place.phone_2,
                                phone_3: place.phone_3,
                            }}
                            images={place.images}
                        />

                        {
                            from === 'places' &&
                            <Fragment>
                                <Comments/>
                                {
                                    place.id && <Courses category={category.id} place={place} product={0}/>
                                }
                                {
                                    place.id && <Courses category={category.id} place={place} product={1}/>
                                }
                            </Fragment>
                        }
                    </React.Fragment> : <CourseDetails course_id={course_id} />
                }


            </React.Fragment>
        );
    }
}

export default Details;
